<template>
    <NuxtLayout>
        <div class="body-block">
            <div class="title-container">
                <div class="container-xl">
                    <div class="doc-title-container">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h1 class="page_title mt-10">{{ $t('documents.title') }}</h1>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block text-end">
                                <img src="/images/documents/document_view.png" alt="" class="doc-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-documents">
                <div class="container-xl">
                    <div class="contract-block">
                        <h2 class="documents-subtitle">{{ $t('documents.policy.title') }}</h2>
                    </div>
                    <div class="contract-document-block">
                        <div class="flex-column mt-4">
                            <div class="file">
                                <a :href="$t('documents.policy.personalPolicy.link')" class="doc-link-colored text-decoration-none">{{ $t('documents.policy.personalPolicy.title') }}</a>
                            </div>
                        </div>
                        <div class="flex-column mt-4">
                            <div class="file">
                                <a :href="$t('documents.policy.userConsent.link')" class="doc-link-colored text-decoration-none">{{ $t('documents.policy.userConsent.title') }}</a>
                            </div>
                        </div>
                        <div class="flex-column mt-4">
                            <div class="file">
                                <a :href="$t('documents.policy.userConsentAd.link')" class="doc-link-colored text-decoration-none">{{ $t('documents.policy.userConsentAd.title') }}</a>
                            </div>
                        </div>
                        <div class="flex-column mt-4">
                            <div class="file">
                                <a :href="$t('documents.policy.cookies.link')" class="doc-link-colored text-decoration-none">{{ $t('documents.policy.cookies.title') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-xl">
                    <div class="contract-block">
                        <h2 class="documents-subtitle">{{ $t('documents.contracts') }}</h2>
                        <p class="description-block">
                            {{ $t('documents.description1') }}.
                        </p>
                        <p class="description-block">{{ $t('documents.description2') }}</p>
                        <p class="description-block">{{ $t('documents.description3') }}</p>
                        <p class="description-block">{{ $t('documents.note') }}</p>
                        <div class="contract-document-block">
                            <div class="contract-document-block">
                                <div class="filelist flex-column mt-4">
                                    <div v-for="doc in documents" :key="doc.id">
                                        <h3 class="documents-list-title">{{ doc.list_title }}</h3>
                                        <div v-for="doc_item in doc.docs" :key="doc_item.id" class="file">
                                            <a :href="doc_item.link"
                                               class="doc-link-colored text-decoration-none"
                                            >{{ doc_item.anchor }}</a>
                                            <hr>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">

const runtimeConfig = useRuntimeConfig();
const documents = [
    {
        list_title: 'Договоры',
        id: 1,
        docs: [
            {
                id: 1,
                title: 'Договор транспортно-экспедиционного обслуживания (Публичная оферта для резидентов Казахстана)',
                link: '/upload/Договор_ТЭО_ПЭК_Казахстан_2025_(Резиденты_РК).docx',
                anchor: 'Договор транспортно-экспедиционного обслуживания (Публичная оферта для резидентов Казахстана)'
            },
            {
                id: 2,
                title: 'Договор транспортной экспедиции FTL ПЭК Казахстан',
                link: '/upload/Договор транспортной экспедиции FTL ПЭК Казахстан.docx',
                anchor: 'Договор транспортной экспедиции FTL ПЭК Казахстан'
            },
        ],
    },
    {
        list_title: 'Заявления',
        id: 2,
        docs: [
            {
                id: 1,
                title: 'Заявление о перемаркировке груза',
                link: '/upload/Заявление о перемаркировке груза.docx',
                anchor: 'Заявление о перемаркировке груза'
            },
            {
                id: 2,
                title: 'Заявление о приостановке',
                link: '/upload/Заявление о приостановке.docx',
                anchor: 'Заявление о приостановке'
            },
            {
                id: 3,
                title: 'Заявление об изменении грузополучателя',
                link: '/upload/Заявление об изменении грузополучателя.docx',
                anchor: 'Заявление об изменении грузополучателя'
            },
            {
                id: 4,
                title: 'Заявление_на_вынужденное_хранение_для_физических_лиц',
                link: '/upload/Заявление_на_вынужденное_хранение_для_физических_лиц.docx',
                anchor: 'Заявление на вынужденное хранение для физических лиц'
            },

            {
                id: 5,
                title: 'Заявление_на_вынужденное_хранение_для_юридических_лиц.docx',
                link: '/upload/Заявление_на_вынужденное_хранение_для_юридических_лиц.docx',
                anchor: 'Заявление на вынужденное хранение для юридических лиц'
            },
            {
                id: 5,
                title: 'Заявление_об_изменении_объявленной_стоимости',
                link: '/upload/Заявление_об_изменении_объявленной_стоимости.docx',
                anchor: 'Заявление об изменении объявленной стоимости'
            },
            {
                id: 6,
                title: 'Заявление_об_изменении_плательщика',
                link: '/upload/Заявление_об_изменении_плательщика.docx',
                anchor: 'Заявление об изменении плательщика'
            },
        ],
    },
    {
        list_title: 'Письма о грузе',
        id: 3,
        docs: [
            {
                id: 1,
                title: 'Сопроводительное_письмо_для_резидентов_РК',
                link: '/upload/Сопроводительное_письмо_для_резидентов_РК.docx',
                anchor: 'Сопроводительное письмо для резидентов РК'
            },
        ]
    },
    {
        list_title: 'Доверенности',
        id: 4,
        docs: [
            {
                id: 1,
                title: 'Доверенность на получение грузов на территории Республики Казахстан (для физических лиц)',
                link: '/upload/Доверенность на получение грузов на территории Республики Казахстан (для физических лиц).docx',
                anchor: 'Доверенность на получение грузов на территории Республики Казахстан (для физических лиц)'
            },
            {
                id: 2,
                title: 'Доверенность_на_получение_груза_ на территории Республики Казахстан (для ЮЛ и ИП)',
                link: '/upload/Доверенность_на_получение_груза_ на территории Республики Казахстан (для ЮЛ и ИП).docx',
                anchor: 'Доверенность_на_получение_груза_ на территории Республики Казахстан (для ЮЛ и ИП)'
            },
            {
                id: 3,
                title: 'Образец доверенности_на_забор_груза_для_резидентов_Казахстана',
                link: '/upload/Образец доверенности_на_забор_груза_для_резидентов_казахстана.docx',
                anchor: 'Образец доверенности на забор груза для резидентов Казахстана'
            },
        ]
    },
];
useHead({
    script: [
        {
            src: runtimeConfig.public.API_MAPS_YANDEX_GET,
        },
    ],
});
</script>

<style></style>
